module.exports = __webpack_public_path__ + "img/etapeMiseEnProd.18e7c6d0.png";